<template>
    <a @click.prevent="send" href="#" class="call-tooltip" data-toggle="tooltip" data-placement="bottom" title="Partager la recette">
        <svg viewBox="0 0 40 44" class="icon blue" style="width:48px; height : 48px">
            <use xlink:href="#html"></use>
        </svg>
    </a>
</template>
<script>
export default {
    methods: {
        send() {
            this.$alert('Réservé aux <a target="_blank" href="https://etiquettable.eco2initiative.com/abonnements/">abonnements pro</a>', '', {
                dangerouslyUseHTMLString: true
            });
        }
    }
}
</script>